var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramColor = function SvgTelegramColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.004,
    y: 0.064,
    fill: "#2F89CE",
    rx: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram-color_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 17.143,
    x: 1.433,
    y: 1.492,
    fill: "#2F89CE",
    rx: 2.857
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.005,
    cy: 10.064,
    r: 8.571,
    fill: "#2F89CE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m5.44 10.224 1.97.735.77 2.472c.033.167.233.2.367.1l1.102-.902c.1-.1.267-.1.4 0l1.971 1.436c.134.1.334.034.368-.133l1.47-7.014c.033-.167-.134-.334-.301-.268L5.44 9.79c-.2.067-.2.367 0 .434m2.639.367 3.874-2.37c.067-.034.134.066.067.1l-3.173 2.972c-.1.1-.2.234-.2.4l-.1.802c0 .1-.167.134-.2 0l-.402-1.47c-.1-.166-.033-.367.134-.434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram-color_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.433 1.492h17.143v17.143H1.433z"
  })))));
};
export default SvgTelegramColor;